import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';
import { Button } from '../ui-common/button';
import { cn } from '../../lib/utils';

const VideoPopup = ({ panoptoURL, title, children, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);
  const [show, setShow] = useState(false);

  const openPopup = () => {
    setIsOpen(true);
    setTimeout(() => setShow(true), 10);
  };

  const closePopup = () => {
    setShow(false);
    setTimeout(() => setIsOpen(false), 300); // wait for transition
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const videoSrc = panoptoURL.replace('Viewer.aspx', 'Embed.aspx') + '&autoplay=true&offerviewer=true&showtitle=true&showbrand=false&captions=true&interactivity=none';

  const popupContent = (
    <div className={`fixed inset-0 bg-black/20 backdrop-blur-sm z-[999] flex justify-center items-center transition-opacity duration-300 ${show ? 'opacity-100' : 'opacity-0'}`}>
      <div 
        ref={popupRef} 
        className={`bg-background rounded-lg shadow-2xl w-full max-w-2xl h-auto max-h-[80vh] flex flex-col p-3 border transform transition-all duration-300 ${show ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
        <div className="flex justify-between items-center mb-2">
          <h3 className="font-semibold text-lg pl-2">{title}</h3>
          <Button variant="ghost" size="icon" onClick={closePopup} className="hover:bg-primary/10 hover:text-primary rounded-full">
            <X className="h-5 w-5" />
          </Button>
        </div>
        <div className="relative w-full h-0 rounded-md overflow-hidden" style={{ paddingBottom: '56.25%' }}>
          <iframe
            src={videoSrc}
            className="absolute top-0 left-0 w-full h-full border-0"
            allowFullScreen
            allow="autoplay"
            aria-label="Panopto Embedded Video Player"
            aria-description={title}
          />
        </div>
      </div>
    </div>
  );

  return (
    <>
      <a onClick={openPopup} className={cn("cursor-pointer hover:underline", className)}>
        {children}
      </a>
      {isOpen && ReactDOM.createPortal(popupContent, document.body)}
    </>
  );
};

export default VideoPopup;
